<template>
  <transition name="fade" tag="div" class="wrapper" mode="out-in">
    
    <div class="wrapper" v-if="isLoaded" id="app">
      <LandingPage :user="user" />
      <Description :user="user" :content="findSlug('description')" :links="findSlug('links')" />
      <Experience :content="findSlug('experiences')" />
      <Skills :skills="skills" />
      <Projects :projects="projects" />
      <Footer :user="user" :links="findSlug('links')" />
    </div>
  </transition>
</template>

<script>
import LandingPage from "./components/LandingPage.vue";
import Description from "./components/Description.vue";
import Experience from "./components/Experience.vue";
import Skills from "./components/Skills.vue";
import Projects from "./components/Projects.vue";
import Footer from "./components/Footer.vue";
import { portfolioData } from "../src/data";

export default {
  name: "App",
  components: {
    LandingPage,
    Description,
    Experience,
    Skills,
    Projects,
    Footer,
  },
  data: () => ({
    isLoaded: false,
    user: {},
    posts: [],
    skills: [],
    projects: [],
  }),
  methods: {
    fetchProjects() {
      var filteredObj = portfolioData.filter(function(item) { return item.order === 0; });
      return filteredObj[0]
    },
    fetchPosts() {
      var filteredObj = portfolioData.filter(function(item) { return item.order === 0; });
      return filteredObj[0]
    },
    fetchSkills() {
      var filteredObj = portfolioData.filter(function(item) { return item.order === 1; });
      return filteredObj[0]
    },
    fetchUser() {
      var filteredObj = portfolioData.filter(function(item) { return item.order === 3; });
      return filteredObj[0]
    },
    findSlug(slug) {
      var filteredObj = portfolioData.filter(function(item) { return item.slug === slug; });
      return filteredObj[0]
    }
  },
  created() {
    document.body.classList.add("loading");
    Promise.all([this.fetchPosts(), this.fetchSkills(), this.fetchProjects(), this.fetchUser()]).then(([posts, skills, projects, user_data]) => {
      this.posts = posts.objects;
      this.skills = skills;
      this.projects = projects;
      this.user = {
        name: user_data.metadata.name,
        status: user_data.metadata.status,
        email: user_data.metadata.email,
        phone: user_data.metadata.phone,
        city: user_data.metadata.city,
        lang: user_data.metadata.lang,
        photo: user_data.metadata.photo,
      }
      this.isLoaded = true;
      this.$nextTick(() => document.body.classList.remove("loading"));
    });
  },
};
</script>

<style scoped lang="scss">
@import "./styles/constants.scss";

#app {
  font-family: Montserrat-Regular, serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.wrapper {
  height: 100%;
}
</style>
